import { render, staticRenderFns } from "./notificationsList.vue?vue&type=template&id=a0548f78&scoped=true"
import script from "./notificationsList.vue?vue&type=script&lang=js"
export * from "./notificationsList.vue?vue&type=script&lang=js"
import style0 from "./notificationsList.vue?vue&type=style&index=0&id=a0548f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0548f78",
  null
  
)

export default component.exports